// extracted by mini-css-extract-plugin
module.exports = {"container":"OtpCodeInput_container__9sVmW","updatedStyles":"OtpCodeInput_updatedStyles__3A_uG"};